import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCar3Ev: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCar3Ev"><Path d="M19.75 17.5H22.5V14.849C22.5 11.8842 20.4073 9.08146 17.5 8.5L14.25 4.5H7.21208C3.96434 4.5 1.5 7 1.5 11.0819V17.5H4.25" stroke="currentColor" strokeLinecap="square"/><Path d="M9.75 17.5H14.25" stroke="currentColor"/><Circle cx="7" cy="17" r="2.5" stroke="currentColor"/><Circle cx="17" cy="17" r="2.5" stroke="currentColor"/><Path d="M14.5 10H11.9167L12.3334 7L8.5 12H11.0833L10.6667 15L14.5 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCar3Ev;
